import { HTTP_TOKEN_REPORT } from "./http";

export const getInsight = (params) => {
  return HTTP_TOKEN_REPORT.get("insight", { params }).then((result) => {
    return result.data;
  });
};
